import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

const IntegrationsAiTableSpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {item.space ? (
        <SpacePath spaceId={item.space.id} fallbackName={item.space.name} />
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableSpaceCell;
